import React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

import { Loader } from '../Loader';
import { Error } from '../Error';
import { NoResult } from '../NoResult';

import Widget, { WidgetTitle, WidgetContent } from './Widget';
import Clear from '../Clear';
import Select from '../forms/Select';

const Brands = styled.div`
  margin-bottom: 10px;
`;

const Models = styled.div`
  margin-bottom: 10px;
`;

const Types = styled.div`
  margin-bottom: 10px;
`;

const GET_BRANDS = gql`
  query getCarBrands {
    brands: getAllCarBrands {
      value: BilNr
      label: BilmarkeNamnNorge
    }
  }
`;

const GET_MODELS = gql`
  query getCarModels($brandId: String!) {
    models: getCarModels(BilNr: $brandId) {
      value: ModellNr
      label: ModellNamn
    }
  }
`;

const GET_VARIANTS = gql`
  query getCarModelVariants($brandId: String!, $modelId: String!) {
    variants: getCarModelVariants(BilNr: $brandId, ModellNr: $modelId) {
      value: Bilkod
      label: BilkodNamnNorge
    }
  }
`;

function CarSelectWidget({ location, history }) {
  const query = qs.parse(location.search, { arrayFormat: 'bracket' });

  const brandId = query.merke || undefined;
  const modelId = query.modell || undefined;
  const variantId = query.variant || undefined;

  const handleClear = () => {
    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          merke: undefined,
          modell: undefined,
          variant: undefined,
          regnr: undefined
        },
        { arrayFormat: 'bracket' }
      )
    });
  };

  const handleBrandSelect = brand => {
    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          merke: brand.value,
          modell: undefined,
          variant: undefined,
          regnr: undefined
        },
        { arrayFormat: 'bracket' }
      )
    });
  };

  const handleModelSelect = model => {
    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          merke: brandId,
          modell: model.value,
          variant: undefined,
          regnr: undefined
        },
        { arrayFormat: 'bracket' }
      )
    });
  };

  const handleVariantSelect = variant => {
    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          merke: brandId,
          modell: modelId,
          variant: variant.value,
          regnr: undefined
        },
        { arrayFormat: 'bracket' }
      )
    });
  };

  return (
    <Widget>
      <WidgetTitle>Bilmerker</WidgetTitle>

      <WidgetContent>
        <Clear onClearClick={handleClear} />

        <Brands>
          <Query query={GET_BRANDS}>
            {({ loading, error, data }) => {
              if (loading) {
                return <Loader />;
              }

              if (error) {
                return <Error error={error} />;
              }

              if (!data.brands) {
                return <NoResult msg="Ingen bilmerker ble funnet!" />;
              }

              return (
                <Select
                  items={data.brands}
                  name="car-brands-select"
                  placeholder="Velg merke…"
                  value={data.brands.find(brand => brand.value === brandId)}
                  onSelectChange={handleBrandSelect}
                />
              );
            }}
          </Query>
        </Brands>

        {brandId && (
          <Models>
            <Query
              query={GET_MODELS}
              variables={{
                brandId: brandId
              }}
            >
              {({ loading, error, data }) => {
                if (loading) {
                  return <Loader />;
                }

                if (error) {
                  return <Error error={error} />;
                }

                if (!data.models) {
                  return <NoResult msg="Ingen modeller ble funnet!" />;
                }

                return (
                  <Select
                    items={data.models}
                    name="car-models-select"
                    placeholder="Velg modell…"
                    value={data.models.find(model => model.value === modelId)}
                    onSelectChange={handleModelSelect}
                  />
                );
              }}
            </Query>
          </Models>
        )}

        {brandId &&
          modelId && (
            <Types>
              <Query
                query={GET_VARIANTS}
                variables={{
                  brandId: brandId,
                  modelId: modelId
                }}
              >
                {({ loading, error, data }) => {
                  if (loading) {
                    return <Loader />;
                  }

                  if (error) {
                    return <Error error={error} />;
                  }

                  if (!data.variants) {
                    return <NoResult msg="Ingen varianter ble funnet!" />;
                  }

                  return (
                    <Select
                      items={data.variants}
                      name="car-variants-select"
                      placeholder="Velg type…"
                      value={data.variants.find(
                        variant => variant.value === variantId
                      )}
                      onSelectChange={handleVariantSelect}
                    />
                  );
                }}
              </Query>
            </Types>
          )}
      </WidgetContent>
    </Widget>
  );
}

export default withRouter(CarSelectWidget);
